import { get } from "@rails/request.js"

// Queues an async export; the server answers with a turbo stream flash, so the
// page isn't reloaded. Anything else (e.g. a sign-in redirect) falls back to a
// regular visit.
export async function requestExport(url) {
  const response = await get(url, { responseKind: "turbo-stream" })

  if (!response.ok || !response.isTurboStream) {
    window.location.assign(url)
  }
}
